/* eslint-disable */

import mainComponent from '../../mainComponent'
import api from '../../../resources/apiProvider'
import DatePicker from 'vue2-datepicker'
import cleanObject from 'clean-deep'
import _ from 'lodash'
import moment from 'moment'
import queryString from 'query-string'
import Multiselect from 'vue-multiselect'
import toastr from 'toastr/build/toastr.min'
import tableHelper from "../../../resources/tableHelper"
import helperGlobal from '../../../services/helperService'

import yadcf from 'yadcf'

import router from '../../../router';

const columnFilterDef = [
    {
        column_number: 0,
        column_data_type: "html",
        html_data_type: "text",
        filter_default_label: "Select indicator",
    }
]

export default {
    components: {mainComponent, DatePicker, Multiselect},
    data() {
        return {
            data: [],
            transformedData: [],
            filters: {
                startDate: '',
                endDate: ''
            },
            loaders: {
                dw_pam: false
            },
            hasData: false,
        }
    },
    beforeRouteUpdate (to, from, next) {
        let tableContainer = $('#js-dom-table-container')
        tableContainer.empty()

        next()
    },
    created() {
        let allParams = _.clone(this.$route.params)
        this.filters = allParams
    },
    mounted() {
        this.loadHighLevelFilters()

        /*this.$nextTick(function () {
            this.getData(this.getAllFilters, (data) => {
                //let arr = tableHelper.getDataBetween2Dates(this.initialData, this.filters.startDate, this.filters.endDate)
                this.data = data
                this.hasData = true
                this.renderTable()
            })
        })*/
    },
    watch: {

    },
    methods: {
        /**
         * Récupération des données depuis l'API
         *
         * @param params
         * @param callback
         * @returns {Promise<void>}
         */
        async getData(params = {}, callback) {
            let res = api.getFromUri(api.getResourceUri().pam.all)
            let result = await res.save(params, {})
            callback(result.data)
        },
        normalizer(node) {
            const normalizedNode = {
                _id: node._id,
                desc: node.desc,
                id: node._id,
                label: node._id + ' - ' + node.desc
            }

            if(node.children && node.children.length > 0) {
                normalizedNode.children = node.children.map(this.normalizer)
            }

            return normalizedNode
        },
        /**
         * Récupérer les paramètres de l'url
         */
        loadHighLevelFilters() {
            let vm = this
            let allParams = _.clone(vm.$route.params)
            // gestion des filtres haut niveau
            if (!_.isUndefined(allParams.filters)) {
                let passFilters = queryString.parse(allParams.filters)
                vm.filters = passFilters
            }
        },
        /**
         * Transformation des données brutes et initialisation du tableau DataTable
         */
        renderTable() {
            let tableContainer = $('#js-dom-table-container')
            let dtTableJq = tableHelper.createTableDomElement(tableContainer)
            let columnDefs = [
                { data: 'modificationDate', title: 'Date/heure dernière modification', targets: 0, defaultContent: '' },
                { data: 'creationDate', title: 'Date/heure création', targets: 1, defaultContent: '' },
                { data: 'clientId', title: 'N° identifiant client', targets: 2, defaultContent: '' },
                { data: 'courseNum', title: 'N° course', targets: 3, defaultContent: '' },
                { data: 'clientName', title: 'Nom client', targets: 4, defaultContent: '' },
                { data: 'adressePEC', title: 'Adresse prise en charge', targets: 5, defaultContent: '' },
                { data: 'cpPEC', title: 'Code postal prise en charge', targets: 6, defaultContent: '' },
                { data: 'villePEC', title: 'Commune prise en charge', targets: 7, defaultContent: '' },
                { data: 'adresseDepose', title: 'Adresse dépose', targets: 8, defaultContent: '' },
                { data: 'cpDepose', title: 'Code postal dépose', targets: 9, defaultContent: '' },
                { data: 'villeDepose', title: 'Commune dépose', targets: 10, defaultContent: '' },
                { data: 'motifCourse', title: 'Motif course', targets: 11, defaultContent: '' },
                { data: 'frequence', title: 'Fréquence', targets: 12, defaultContent: '' },
                { data: 'niveauPriorite', title: 'Niveau priorité', targets: 13, defaultContent: '' },
                { data: 'kmVolOiseau', title: 'Kilométrage vol d\'oiseau', targets: 14, defaultContent: '' },
                { data: 'trancheTarif', title: 'Tranche tarifaire', targets: 15, defaultContent: '' },
                { data: 'vehicleNum', title: 'N° véhicule', targets: 16, defaultContent: '' },
                { data: 'driverNum', title: 'N° conducteur', targets: 17, defaultContent: '' },
                { data: 'departureDateAsked', title: 'Date/heure départ demandée', targets: 18, defaultContent: '' },
                { data: 'arrivalDateAsked', title: 'Date/heure arrivée demandée', targets: 19, defaultContent: '' },
                { data: 'choixHeureImperative', title: 'Choix heure impérative', targets: 20, defaultContent: '' },
                { data: 'departureDateAgreed', title: 'Date/heure départ convenue', targets: 21, defaultContent: '' },
                { data: 'arrivalDateAgreed', title: 'Date/heure arrivée convenue', targets: 22, defaultContent: '' },
                { data: 'dureeTrajetDirect', title: 'Durée trajet direct', targets: 23, defaultContent: '' },
                { data: 'clientTPC', title: 'TPC client', targets: 24, defaultContent: '' },
                { data: 'departureSpecificTime', title: 'Temps spécifique départ', targets: 25, defaultContent: '' },
                { data: 'arrivalSpecificTime', title: 'Temps spécifique arrivée', targets: 26, defaultContent: '' },
                { data: 'annexTime', title: 'Temps annexe', targets: 27, defaultContent: '' },
                { data: 'departureDatePlanned', title: 'Date/heure départ planifiée', targets: 28, defaultContent: '' },
                { data: 'arrivalDatePlanned', title: 'Date/heure arrivée planifiée', targets: 29, defaultContent: '' },

                /*{ data: 'effectiveDepartureDate', title: 'Date/heure départ réelle', targets: 9, defaultContent: '' },
                { data: 'effectiveArrivalDate', title: 'Date/heure arrivée réelle', targets: 14, defaultContent: '' },*/

                { data: 'effectiveDepartureDate', title: 'Date/heure arrivée lieu prise en charge', targets: 30, defaultContent: '' },
                { data: 'effectiveDeparturePEC', title: 'Date/heure départ prise en charge', targets: 31, defaultContent: '' },
                { data: 'effectiveArrivalDate', title: 'Date/heure arrivée lieu dépose', targets: 32, defaultContent: '' },

                { data: 'presenceAccompagnantPayant', title: 'Présence accomp. payant(s)', targets: 33, defaultContent: '' },
                { data: 'soldeCreationMission', title: 'Solde à la création de la mission', targets: 34, defaultContent: '' },
                { data: 'groupage', title: 'Course groupée', targets: 35, defaultContent: '' },
            ]
            let dt2 = dtTableJq.DataTable({
                dom: 'lBfrtip',
                data: this.transformedData,
                //columns: dataByDateCol.columnsDtFormated,
                columnDefs: columnDefs,
                lengthMenu: [[10, 50, -1], [10, 50, "All"]],
                buttons: [
                    {
                        extend: 'excelHtml5',
                        text: 'Excel',
                        filename: this.getExportName(),
                        title: '',
                        exportOptions: {
                            orthogonal: 'exportExcel'
                        }
                    },
                    {
                        extend: 'csvHtml5',
                        text: 'CSV',
                        filename: this.getExportName(),
                        title: '',
                        exportOptions: {
                            orthogonal: 'exportCsv'
                        }
                    }
                ],
                scrollX: true,
                autoWidth: true
            })
            dt2.columns.adjust
            //yadcf.init(dt2, columnFilterDef)
        },
        /**
         *  Lance la recherche si l'utilisateur valide
         */
        async clickEventSearchBtn() {
            const Count = api.getFromUri(api.getResourceUri().pam.count)
            console.log(this.getAllFilters)
            const result = await Count.save(this.getAllFilters, {})
            const confirmationMsg = `Cette requête remonte ${result.data} lignes. Voulez-vous continuer?`

            // On demande confirmation avant de lancer le traitement
            helperGlobal.confirm(confirmationMsg, () => {
                this.loaders.dw_pam = true
                this.getData(this.getAllFilters, (data) => {
                    this.data = data
                    this.transformedData = this.transformData(data)
                    this.hasData = true
                    this.loaders.dw_pam = false
                    let tableContainer = $('#js-dom-table-container')
                    tableContainer.empty()
                    this.renderTable()
                })
            })
        },
        getExportName() {
            return 'Rapprochement XE Kuantic ' +
                '-' +
                moment(this.filters.startDate).format('DD_MM_YYYY') +
                '-' +
                moment(this.filters.endDate).format('DD_MM_YYYY')
        },
        transformData(data) {
            let transformedData = []
            data.forEach(function(item) {
                let newItem = _.clone(item)

                newItem.modificationDate = (item.modificationDate) ? moment.utc(item.modificationDate).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.creationDate = (item.creationDate) ? moment.utc(item.creationDate).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.arrivalDateAgreed = (item.arrivalDateAgreed) ? moment.utc(item.arrivalDateAgreed).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.arrivalDateAsked = (item.arrivalDateAsked) ? moment.utc(item.arrivalDateAsked).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.arrivalDatePlanned = (item.arrivalDatePlanned) ? moment.utc(item.arrivalDatePlanned).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.departureDateAgreed = (item.departureDateAgreed) ? moment.utc(item.departureDateAgreed).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.departureDateAsked = (item.departureDateAsked) ? moment.utc(item.departureDateAsked).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.departureDatePlanned = (item.departureDatePlanned) ? moment.utc(item.departureDatePlanned).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.effectiveArrivalDate = (item.effectiveArrivalDate) ? moment.utc(item.effectiveArrivalDate).format('DD/MM/YYYY HH:mm:ss') : ''
                newItem.effectiveDepartureDate =(item.effectiveDepartureDate) ? moment.utc(item.effectiveDepartureDate).format('DD/MM/YYYY HH:mm:ss') : ''

                newItem.groupage = (item.groupage == true) ? 'Oui' : 'Non'

                transformedData.push(newItem)
            })
            return transformedData
        }
    },
    computed: {
        /**
         * retourne les filtres de haut niveau,
         * @returns {*}
         */
        getAllFilters() {
            let filters = _.clone(cleanObject(this.filters))
            if (filters.startDate) {
                filters.startDate = moment(filters.startDate).startOf('day').format()
            }
            if (filters.endDate) {
                filters.endDate = moment(filters.endDate).endOf('day').format()
            }
            return _.clone(filters)
        },
        /**
         * renvoit les conditions de desactivation du
         * bouton de la recherche
         * @returns {boolean}
         */
        startDate() {
            return this.filters.startDate
        },
        endDate() {
            return this.filters.endDate
        },
        /**
         * renvoit les conditions de desactivation du
         * bouton de la recherche
         * @returns {boolean}
         */
        btnSearchDisable() {
            let conditions = this.loaders.dw_pam // || _.isEmpty(this.getAllFilters);
            return conditions
        },
    },
    destroyed() {
    }
}